<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>工作圈管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>工作圈管理</h4>
        <p @click="addwork"
           :style="{'border':'none','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">+新增工作圈</p>
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <worksetuptable :tableData="tableList"
                          @changeClick="changeClick"
                          @relationClick="relationClick"
                          @removeClick="removeClick"></worksetuptable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="audialogVisible"
               width="30%"
               :before-close="auhandleClose">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{title}}</div>
      </div>
      <el-form :model="myform"
               ref="myform"
               label-width="70px"
               :rules="rules">
        <el-form-item label="名称："
                      prop="name">
          <el-input v-model="myform.name"
                    placeholder="必填，2-10个字"></el-input>
        </el-form-item>

        <el-form-item label="简介："
                      prop="desc">
          <el-input type="textarea"
                    placeholder="选填，不超过100个字"
                    :autosize="{ minRows: 7}"
                    v-model="myform.desc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="auhandleClose">取 消</el-button>
        <el-button type="primary"
                   v-if="!isClick"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submit('myform')">提 交</el-button>
        <el-button type="primary"
                   v-else
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   disabled>提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="relationdialogVisible"
               width="32%"
               :before-close="relationhandleClose">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>关联用户</div>
      </div>
      <el-form :model="relationform"
               ref="relationform"
               label-width="100px"
               :rules="relationrules">
        <el-form-item label="工作圈："
                      prop="name">
          <div style="font-weight:bolder;">{{relationform.name}}</div>
        </el-form-item>

        <el-form-item label="关联用户："
                      prop="ids">

          <div class="relationBJ"
               ref="userbj">
            <div style="width:100%;height:auto;"
                 ref="checkb"
                 v-loading='relationloading'>
              <el-checkbox-group v-model="relationform.ids">
                <el-checkbox style="width:100px;"
                             v-for="item in userList"
                             :key="item.id"
                             :label="item.id">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="relationhandleClose">取 消</el-button>
        <el-button type="primary"
                   v-if="!isClick"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="relationsubmit('relationform')">提 交</el-button>
        <el-button type="primary"
                   v-else
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   disabled>提 交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { worksetuptable } from "@/components/index";
import { mapGetters } from "vuex";

import { listUser } from "@/api/user";

import { listAccessByWorkgroupId, setAccess, listWorkgroup, updateWorkgroup, addWorkgroup, deleteWorkgroup, } from "@/api/workgroup";
import { getDate, formatConversion } from "@/plugins/getdate";
export default {
  components: {
    worksetuptable
  },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      title: "新增工作圈",
      audialogVisible: false,
      relationdialogVisible: false,
      tableList: [],
      timeInt: '',
      isRefresh: false,
      isClick: false,
      relationloading: false,

      page: 0,
      usertotal: 0,

      myform: {
        name: "",
        desc: "",
        createUid: this.createUid
      },
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        desc: [{ min: 0, max: 100, message: "长度在 100 个字符以内", trigger: "blur" }]
      },

      userList: [],

      relationform: {
        name: '',
        ids: [],
        workgroupId: ''
      },
      relationrules: {
        ids: [
          { required: true, message: "请选择关联用户", trigger: "blur" }
        ]
      },
    };
  },
  methods: {

    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data = { page: (this.currentPage - 1), pageSize: this.pageSize }
      // console.log(data)
      this.listWorkgroupAsync(data)
    },

    //滚动加载图库和图片
    scrollPic () {

      let isBottom =
        this.$refs.userbj.scrollTop + 200 >=
        this.$refs.checkb.offsetHeight;

      if (isBottom) {
        if (this.userList.length !== this.usertotal) {
          this.relationloading = true
          setTimeout(() => {
            this.page++
            this.listUserAsync({ page: this.page, pageSize: 30, userType: 0 })
            this.relationloading = false
          }, 1000);
        }
      }
    },


    //刷新表格
    refresh () {

      this.isRefresh = true
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },
    relationhandleClose () {
      this.$refs.userbj.scrollTop = 0
      this.$refs.userbj.removeEventListener("scroll", this.scrollPic);
      this.relationdialogVisible = false
    },

    relationsubmit (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.isClick = true
          setTimeout(() => {
            this.isClick = false
          }, 2000);

          this.relationform.uids = this.relationform.ids.join()

          delete this.relationform.ids
          delete this.relationform.name
          this.setAccessAsync(this.relationform);

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    auhandleClose () {
      this.audialogVisible = false
    },

    changeClick (data) {
      this.audialogVisible = true;
      this.myform = { ...data.row }
      // this.$router.push('/contributor')
    },

    addwork () {
      this.audialogVisible = true;
      this.myform = {
        name: "",
        desc: "",
        createUid: this.createUid
      }
      // this.$router.push('/contributor')
    },

    submit (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.isClick = true
          setTimeout(() => {
            this.isClick = false
          }, 2000);
          // this.myform.config = this.demo
          if (this.myform.id) {
            this.updateWorkgroupAsync(this.myform)
          } else {
            this.addWorkgroupAsync(this.myform)
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },



    //删除事件
    removeClick (data) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.deleteWorkgroupAsync(data.row.id)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },


    //关联事件
    relationClick (data) {
      this.userList = []
      this.page = 0
      this.listUserAsync({ pageSize: 30, userType: 0 })
      this.listAccessByWorkgroupIdAsync({ workgroupId: data.row.id })
      this.relationform = {
        ids : [],
        name : data.row.name,
        workgroupId : data.row.id,
      }

      setTimeout(() => {
        this.relationdialogVisible = true
        setTimeout(() => {
          this.$refs.userbj.addEventListener("scroll", this.scrollPic);
        }, 200);
      }, 400);

    },

    //获取用户列表
    async listUserAsync (val) {
      let { status, data, message, pagination, errors } = await listUser(val);
      if (status) {
        if (this.page === 0) {
          this.userList = data
        } else {
          for (let i = 0; i < data.length; i++) {
            this.userList.push(data[i])
          }
        }
        this.usertotal = pagination.total
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //获取关联
    async listAccessByWorkgroupIdAsync (val) {
      let { status, data, message, errors } = await listAccessByWorkgroupId(val);
      if (status) {
        if (data.length > 0) {
          let ids = []
          for (let i = 0; i < data.length; i++) {
            ids.push(data[i].uid)
          }

          this.relationform.ids = ids
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //关联
    async setAccessAsync (val) {
      let { status, data, message, errors } = await setAccess(val);
      if (status) {
        this.$message.success('关联成功！');
        this.relationdialogVisible = false
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //删除
    async deleteWorkgroupAsync (val) {
      let { status, data, message, errors } = await deleteWorkgroup(val);
      if (status) {
        this.$message.success('删除成功！');
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //添加
    async addWorkgroupAsync (val) {
      let { status, data, message, errors } = await addWorkgroup(val);
      if (status) {
        this.$message.success("添加成功！");
        this.handleCurrentChange(1);
        this.audialogVisible = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改
    async updateWorkgroupAsync (val) {
      let { status, data, message, errors } = await updateWorkgroup(val);
      if (status) {
        this.audialogVisible = false;
        this.$message.success("修改成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取图片库列表
    async listWorkgroupAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listWorkgroup(val);
      if (status) {
        this.tableList = data;
        this.total = pagination.total

        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    }
  },
  created () {
    this.handleCurrentChange(this.currentPage);

    // this.timeInt = setInterval(() => {
    //   this.handleCurrentChange(this.currentPage);
    // }, 90000);
  },
  beforeDestroy () {  // 组件销毁前调用
    // clearTimeout(this.timeInt)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./worksetupmanage.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}

.relationBJ {
  width: 100%;
  height: 200px;
  overflow-y: auto;
}
::-webkit-scrollbar {
  width: 8px;
  height: 32px;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px;
  height: 38px;
  /* 滚动条滑块长度 */
  background: rgba(24, 94, 212, 0.4);
}

.is-checked ::v-deep .el-checkbox__inner {
  background-color: #3CB035 !important;
  border-color: #3CB035;
}
.is-checked ::v-deep .el-checkbox__label {
  color: #606266;
}
</style>
